import { GatsbyBrowser } from 'gatsby'
import { Footer, Header } from '@/components'

const WITHOUT_LAYOUT_URLS = ['/portfolio']

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return element
}

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props: { uri } }) => {
  // Layout을 적용하지 않을 url을 정의
  if (WITHOUT_LAYOUT_URLS.includes(uri)) {
    return element
  }

  return (
    <>
      <Header />
      {element}
      <Footer />
    </>
  )
}
